import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { defaultCurrency, landingData, defaultLanguage, mainData } from "src/app/interfaces/home.interface";
import { generalSettings } from "src/app/interfaces/general-setting.interface";

@Injectable({ providedIn: 'root' })
export class DefaultStoreService {

    public defaultLanguage: BehaviorSubject<defaultLanguage>;
    public defaultCurrency: BehaviorSubject<defaultCurrency>;
    public generalSettings: BehaviorSubject<generalSettings>;
    public landingData: BehaviorSubject<landingData>;
    public mainData: BehaviorSubject<mainData>;
    public dynamicDataChange: BehaviorSubject<any>;
    public dynamicslug: BehaviorSubject<any>;
    public landinslug: BehaviorSubject<any>;
    public adminslug: BehaviorSubject<any>;


    constructor() {
        this.landingData = new BehaviorSubject<landingData>(null)
        this.mainData = new BehaviorSubject<mainData>(null)
        this.defaultCurrency = new BehaviorSubject<defaultCurrency>(null);
        this.defaultLanguage = new BehaviorSubject<defaultLanguage>(null);
        this.dynamicDataChange = new BehaviorSubject<any>(null);
        this.dynamicslug =new BehaviorSubject<any>(null);
        this.landinslug= new BehaviorSubject<any>(null);
        this.adminslug= new BehaviorSubject<any>(null);
    }

    public get getDefaultLang(): defaultLanguage {
        return this.defaultLanguage.value;
    };

    public get getDefaultCurrency(): defaultCurrency {
        return this.defaultCurrency.value;
    };

    public get getGeneralSetting(): generalSettings {
        return this.generalSettings.value;
    };

    public get getLanding(): landingData {
        return this.landingData.value;
    };

    public get getMainData(): mainData {
        return this.mainData.value;
    }
}